export type BuildElementIdParams = {
  field: string;
  uuid: string;
};

/**
 * Constructs a unique element identifier for mapping issues back to their field.
 *
 * @param params - An object containing parameters to build the element ID.
 * @param params.uuid - The unique identifier for the quote, quote line or quote price.
 * @param params.field - The field name for the element.
 * @returns A string representing the constructed element ID.
 */
export function buildElementId({ uuid, field }: BuildElementIdParams) {
  return `${uuid}.${field}`;
}
